export enum Environment {
  LOCAL, // localhost:3000/
  DEV, // Ephemeral Environments
  STAGING, // staging.bopportunities.com
  PROD, // arpeggi.io
  RINKEBY // Deprecated. test environment where rinkeby is used.
}
